let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvxvv")).then(() => parcelRequire('2j1uF'));